<template>
  <div class="vx-row">
    <vx-card class="titlevx-card">
      <h4 style="display:inline-block;margin-top:10px;">{{$t("EventRecordings")}}</h4>
      <vs-button style="float:right;" @click="$router.push({ path: '/admin/event/past' })">{{$t("Back")}}</vs-button>
    </vx-card>
    <vx-card class="titlevx-card">
			<vs-tabs>
				<vs-tab :label="$t('RecordingTimings')">
					<vs-table
						:data="recordings">

						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>{{ data[indextr].action == "start" ? $t("run_event.start_recording") : $t("run_event.stop_recording") }}</vs-td>
								<vs-td>{{ getTime(data[indextr].action_time) }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
				<vs-tab
					:label="$t('Download')"
				>
					<vs-table
						:data="recordingFiles">

						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>{{ data[indextr] }}</vs-td>
								<vs-td><a :href="data[indextr]" download target="_blank"><vs-button color="primary" type="border" icon="file_download"></vs-button></a></vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tab>
			</vs-tabs>
    </vx-card>
  </div>
</template>
<style scoped>
.show-seprator {
  border-bottom: 1px;
}
</style>

<script>
export default {
  data() {
    return {
      event_id: this.$route.params.id,
      eventInfo: [],
      recordings: [],
      recordingFiles: [],
    };
  },
  beforeMount() {
    this.getEventRecordings();
  },
  methods: {

		/**
     * Get date diff
     * @author Bhagwan Sawant
     */
		getTime(val){
			let streamingDate = new Date(this.eventInfo.data.streaming_started_datetime);
			let dateTime = new Date(val);
			console.log(streamingDate);
			console.log(dateTime);
			let diffMs = (dateTime - streamingDate); // milliseconds
			let diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
			let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
			var seconds = ((diffMs % 60000) / 1000).toFixed(0);
			return (diffHrs < 10 ? "0" : "")+diffHrs+ ":" +(diffMins < 10 ? "0" : "")+ diffMins + ":"+(seconds < 10 ? "0" : "") + seconds;
		},

		/**
     * Dwonload recording file
     * @author Bhagwan Sawant
     */
    downloadRecording(link) {
      this.$vs.loading();
      this.$store
        .dispatch("downloadRecording", {"link": link})
        .then(res => {
          this.$vs.loading.close();
          var data = res.data;
          // Success response
          var fileURL = window.URL.createObjectURL(new Blob([data], { type: 'video/mp4' }));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            link.substring(link.lastIndexOf('/')+1)
          );
          document.body.appendChild(fileLink);

          fileLink.click();

          this.$vs.notify({
            color: "success",
            title: "Download Success",
            text: "File downloaded successfully!!",
            position: "top-center"
          });
        })
        .catch(error => {
          this.$log.error('File : Recordings.vue | Function : downloadRecording() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to download file, please try again",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },

    /**
     * Get event info
     * @author Bhagwan Sawant
     */
    getEventRecordings() {
      this.$vs.loading();
      this.$store
        .dispatch("getEventRecordings", this.event_id)
        .then(response => {
          this.eventInfo = response.data.data;
					console.log(this.eventInfo);
          if (this.eventInfo) {
						this.recordings = this.eventInfo.data.recordings;
						this.recordingFiles = this.eventInfo.data.fileLinks.conference_history[0].recording.files;
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : getEventRecordings() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to load data",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
  }
};
</script>
<style scoped>
.titlevx-card {
  width: 97%;
  margin: 0 auto;
  margin-bottom: 2% !important;
}

.vs-popup--background {
  opacity: 0.2 !important;
  background: none !important;
}
</style>
